import { Button } from '@mui/material';
import SyncWizardFooterWrapper from 'components/SyncWizardFooterWrapper';

/** Wizard footer per the wireframes: outlined Back on the left, contained Next on the right. */
export default function StepFooter({ onBack, onNext, nextLabel = 'Next', backDisabled = false, nextDisabled = false }) {
  return (
    <SyncWizardFooterWrapper
      sxOverrides={{ justifyContent: 'space-between', mt: 4, pt: 2.25, borderTop: 1, borderColor: 'divider' }}
    >
      <Button variant="outlined" onClick={onBack} disabled={backDisabled}>
        Back
      </Button>
      <Button variant="contained" onClick={onNext} disabled={nextDisabled}>
        {nextLabel}
      </Button>
    </SyncWizardFooterWrapper>
  );
}
